import React from 'react';

import Text from '@components/common/Text/Text';

import css from './Navigation.module.scss';

type NavigationProps = {
    thematics: any;
    onSelectThematic: (thematic: any) => void;
    selectedThematic: any;
};

const Navigation = ({ thematics, onSelectThematic, selectedThematic }: NavigationProps) => {
    return (
        <div className={css.navigation}>
            {thematics.map((thematic) => {
                return (
                    <div key={`${thematic.thematicID}__thematic`} onClick={() => onSelectThematic(thematic)}>
                        <Text
                            customClass={`${css.trigger} ${
                                selectedThematic &&
                                Number(selectedThematic.thematicID) === thematic.thematicID &&
                                css.trigger__active
                            }`}
                            variant={'body_01'}
                            color={'txt-primary'}
                        >
                            {thematic.titleTH}
                        </Text>
                    </div>
                );
            })}
        </div>
    );
};

export default Navigation;
